import { serviceOptions } from '@services/api'

export interface GetReferringPhysicianStatsQuery {
  siteId?: number
  departmentCode?: string
  zipCode?: string
}

export interface StatsReferringPhysicianCountDTO {
  total: number
}

export interface StatsReferringPhysicianDepartmentBreakdownDTO {
  departmentCode: string
  total: number
}

export interface StatsReferringPhysicianPostalCodeBreakdownDTO {
  zipCode: string
  total: number
}

export interface StatsReferringPhysicianSpecialtyBreakdownDTO {
  specialty: string
  total: number
}

const getAxiosClient = () => {
  if (!serviceOptions.axios) {
    throw new Error('Axios client is not configured')
  }

  return serviceOptions.axios
}

export const fetchReferringPhysicianStatsCount = async (
  params: GetReferringPhysicianStatsQuery,
): Promise<StatsReferringPhysicianCountDTO> => {
  const response = await getAxiosClient().get<StatsReferringPhysicianCountDTO>(
    '/stats/referring-physicians/count',
    { params },
  )

  return response.data
}

export const fetchReferringPhysicianDepartmentsBreakdown = async (
  params: GetReferringPhysicianStatsQuery,
): Promise<StatsReferringPhysicianDepartmentBreakdownDTO[]> => {
  const response =
    await getAxiosClient().get<StatsReferringPhysicianDepartmentBreakdownDTO[]>(
      '/stats/referring-physicians/departments/breakdown',
      { params },
    )

  return response.data
}

export const fetchReferringPhysicianPostalCodesBreakdown = async (
  params: GetReferringPhysicianStatsQuery,
): Promise<StatsReferringPhysicianPostalCodeBreakdownDTO[]> => {
  const response =
    await getAxiosClient().get<StatsReferringPhysicianPostalCodeBreakdownDTO[]>(
      '/stats/referring-physicians/postalcodes/breakdown',
      { params },
    )

  return response.data
}

export const fetchReferringPhysicianSpecialtiesBreakdown = async (
  params: GetReferringPhysicianStatsQuery,
): Promise<StatsReferringPhysicianSpecialtyBreakdownDTO[]> => {
  const response =
    await getAxiosClient().get<StatsReferringPhysicianSpecialtyBreakdownDTO[]>(
      '/stats/referring-physicians/specialties/breakdown',
      { params },
    )

  return response.data
}
